import { FileUp, Loader2, Trash2 } from "lucide-react";
import { useRef, useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function FileUploader({ requestId, kind, label, hint, files, onChange }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const mine = files.filter((f) => f.kind === kind);

  const upload = async (fileList) => {
    setUploading(true);
    try {
      for (const file of fileList) {
        const fd = new FormData();
        fd.append("kind", kind);
        fd.append("file", file);
        const { data } = await api.post(`/requests/${requestId}/files`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        onChange((prev) => [...prev, data]);
      }
      toast.success("Archivo subido");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = async (fileId) => {
    try {
      await api.delete(`/requests/${requestId}/files/${fileId}`);
      onChange((prev) => prev.filter((f) => f.file_id !== fileId));
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="border rounded-2xl bg-white p-5">
      <p className="font-heading font-semibold mb-1">{label}</p>
      <p className="text-xs text-muted-foreground mb-4">{hint}</p>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".pdf,.png,.jpg,.jpeg,.webp,.heic"
        className="hidden"
        onChange={(e) => e.target.files?.length && upload(Array.from(e.target.files))}
        data-testid={`upload-input-${kind}`}
      />
      <Button
        type="button"
        variant="outline"
        className="rounded-full w-full border-dashed"
        disabled={uploading}
        onClick={() => inputRef.current?.click()}
        data-testid={`upload-btn-${kind}`}
      >
        {uploading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FileUp className="h-4 w-4 mr-2" strokeWidth={1.5} />}
        Seleccionar archivo (PDF o imagen)
      </Button>
      <div className="mt-3 space-y-2">
        {mine.map((f) => (
          <div key={f.file_id} className="flex items-center justify-between bg-secondary rounded-xl px-3 py-2" data-testid={`uploaded-file-${f.file_id}`}>
            <span className="text-sm truncate">{f.original_filename}</span>
            <button type="button" onClick={() => remove(f.file_id)} className="text-destructive hover:opacity-70" data-testid={`delete-file-${f.file_id}`}>
              <Trash2 className="h-4 w-4" strokeWidth={1.5} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
